import localeEn from "../air-datepicker/locale/en";
import { format } from "date-fns";

export default class Calendar {
    constructor(el = null) {
        if (!el) return;
        this.calendarEl = el;
        this.today = new Date();
        this.eventsData = this.calendarEl.dataset.events ? JSON.parse(this.calendarEl.dataset.events) : [];
        this.init();
    }

    init() {
        const theClass = this;
        new AirDatepicker(this.calendarEl, {
            locale: localeEn,
            inline: true,
            keyboardNav: false,
            moveToOtherMonthsOnSelect: false,
            showOtherMonths: false,
            navTitles: {
                days: ''
            },
            prevHtml: `<svg xmlns="http://www.w3.org/2000/svg" width="26" height="16" viewBox="0 0 26 16" fill="none"><path d="M0.292892 8.70711C-0.0976315 8.31658 -0.0976315 7.68342 0.292892 7.29289L6.65685 0.928932C7.04738 0.538408 7.68054 0.538408 8.07107 0.928932C8.46159 1.31946 8.46159 1.95262 8.07107 2.34315L2.41421 8L8.07107 13.6569C8.46159 14.0474 8.46159 14.6805 8.07107 15.0711C7.68054 15.4616 7.04738 15.4616 6.65685 15.0711L0.292892 8.70711ZM26 9L1 9V7L26 7V9Z" fill="black"/></svg>`,
            nextHtml: `<svg xmlns="http://www.w3.org/2000/svg" width="26" height="16" viewBox="0 0 26 16" fill="none"><path d="M25.7071 8.70711C26.0976 8.31658 26.0976 7.68342 25.7071 7.29289L19.3431 0.928932C18.9526 0.538408 18.3195 0.538408 17.9289 0.928932C17.5384 1.31946 17.5384 1.95262 17.9289 2.34315L23.5858 8L17.9289 13.6569C17.5384 14.0474 17.5384 14.6805 17.9289 15.0711C18.3195 15.4616 18.9526 15.4616 19.3431 15.0711L25.7071 8.70711ZM0 9L25 9V7L0 7L0 9Z" fill="black"/></svg>`,
            onRenderCell({date, cellType}) {
                const formattedSearchDate = format(date, "yyyy/MM/dd");
                const matchingEvents = Object.values(theClass.eventsData).filter(event => event.date === formattedSearchDate);

                if (matchingEvents.length > 0) {
                    return {
                        html: `
                        <a href="${matchingEvents[0].url}" target="_blank" class="size-full flex flex-col gap-2 justify-center">
                            <span class="event-place">${matchingEvents[0].time} / ${matchingEvents[0].place}</span>
                            <span class="event-date">${date.toLocaleString('en-US', {month: 'short'})}<br />${date.getDate()}</span>
                            <span class="event-title">${matchingEvents[0].title}</span>
                        </a>
                        `,
                        classes: 'has-event',
                    }
                }

                return {
                    html: `<span class="uppercase leading-none text-center">${date.toLocaleString('en-US', {month: 'short'})}<br />${date.getDate()}</span>`,
                }
            },
        });
    }
}